<template>
  <v-dialog
    v-model="isVisible"
    max-width="500"
    :persistent="isLoading"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        outlined
        small
        color="primary"
      >
        Dupliquer
      </v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
      >
        <v-btn
          @click="isVisible = false"
          icon
          :disabled="isLoading"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>Dupliquer un cours</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pt-5">
        <!-- Introduction -->
        <div>
          Vous êtes sur le point de créer un nouveau cours sur la plateforme Moodle.
          Une fois votre sélection effectuée, vous obtiendrez le rôle enseignant
          dans ce nouveau cours et perdrez ce rôle dans le cours d'origine.
        </div>

        <!-- Inscriptions des étudiants -->
        <div class="mt-2 font-weight-bold text-decoration-underline">
          Inscriptions des étudiants
        </div>

        <ul>
          <li>
            Les étudiants restent inscrits dans le cours d'origine.
          </li>

          <li>
            Ils doivent s'inscrire via leur propre interface "Gérer mes cours",
            en vous choisissant comme enseignant.
          </li>

          <li>
            Invitez vos étudiants à visiter celle-ci,
            afin qu'ils migrent vers votre espace de cours.
          </li>
        </ul>

        <!-- Actions -->
        <div class="mt-2 font-weight-bold text-decoration-underline">
          Actions
        </div>

        <ul>
          <li>
            <span class="font-weight-bold">Dupliquer </span>

            <v-icon small class="mb-1">mdi-arrow-right-bold</v-icon>

            <span> copie le cours existant </span>

            <span class="font-weight-bold">avec son contenu éventuel.</span>
          </li>

          <li>
            <span class="font-weight-bold">Créer </span>

            <v-icon small class="mb-1">mdi-arrow-right-bold</v-icon>

            <span> copie le cours existant </span>

            <span class="font-weight-bold">sans son contenu.</span>
          </li>
        </ul>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-row dense>
          <v-col>
            <v-btn
              text
              block
              :disabled="isLoading && !isDuplicating"
              :loading="isLoading && isDuplicating"
              color="primary"
              @click="splitCursus('duplicate')"
            >
              Dupliquer
            </v-btn>
          </v-col>

          <v-col>
            <v-btn
              text
              block
              :disabled="isLoading && isDuplicating"
              :loading="isLoading && !isDuplicating"
              color="primary"
              @click="splitCursus('create')"
            >
              Créer
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'DuplicateCursusDialog',

  props: {
    cursus: Object,
  },

  data: () => ({
    isVisible: false,
    isLoading: false,
    isDuplicating: false,
  }),

  methods: {
    ...mapMutations({ showNotification: 'SET_NOTIFICATION', updateCursus: 'UPDATE_TEACHER_CURSUS' }),

    async splitCursus(action) {
      try {
        let url = '';
        this.isLoading = true;
        if (action === 'duplicate') {
          this.isDuplicating = true;
          url = 'duplicate_course';
        } else {
          url = 'create_course';
        }
        const response = await this.$http.post(`management/${url}.php`, {
          name_course: this.cursus.shortname,
          code: this.cursus.id_number,
          id_category: this.cursus.id_category,
          id_course: this.cursus.id_course,
          fullname: this.cursus.fullname,
          displayname: this.cursus.displayname,
        });
        this.updateCursus({
          oldCursus: this.cursus,
          newCursus: response.data,
        });
        this.showNotification({
          isVisible: true,
          text: `La ${action === 'duplicate' ? 'duplication' : 'création'} du cours a bien été effectuée`,
          color: 'success',
        });
        this.isVisible = false;
      } catch (error) {
        console.log(error);
        this.showNotification({
          isVisible: true,
          text: 'Une erreur est survenue, réessayez',
          color: 'error',
        });
      } finally {
        this.isLoading = false;
        this.isDuplicating = false;
      }
    },
  },
};
</script>
